import { accessRole } from "../../../../../helpers/access_role"
import { config } from "../../../../../helpers/config_global"
import React, { useState, Component, Fragment } from "react"
import { Redirect } from "react-router-dom"
import Shimmer from "react-shimmer-effect";

import { Tooltip, Row, Col } from "reactstrap"

import MKIDatatable from '../../../../../modules/mki-datatable/lib'
import { ConfirmAlert } from '../../../../../helpers/ui/alert'

import { cancelToken } from "../../../../../services/adapters/kepegawaian/skpService"

import DataTableBloc from '../Blocs/DataTableBloc'
import apiResponse from '../../../../../services/apiResponse'

import moment from "moment"

class TableActiveComponent extends Component {
    dataTableBloc = new DataTableBloc();

    source
    historyTable = 'historySKPtargetActive'
    defaultOrder = 'skp_id'
    defaultSize = 10
    defaultSort = 'desc'
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        }
    }

    constructor(props) {
        super(props)
        this.state = {
            tooltip: false,
            detailUuid: null,
            updateUuid: null,
            inactiveUuid: null,
            defaultSize: 10,
            rows: [],
            totalRow: 0,
            loadingTable: true,
            filter: sessionStorage.getItem(this.historyTable) ?
                JSON.parse(sessionStorage.getItem(this.historyTable)) :
                {
                    filter_value: "",
                    page_number: 1,
                    page_size: this.defaultSize,
                    sort_order: {
                        column: this.defaultOrder,
                        order: this.defaultSort
                    }
                }
        }
    }

    dateParse = (input) =>{
        let res = "";
        if (input != "" && input != null){
          res = moment(input).format('DD/MM/YYYY')
        }
        return res;
    }

    getEmployeeBirthDetail = (emp) => {
        let res = "";
        if (emp.employee_place_of_birth_city_uuid != null && emp.employee_place_of_birth_city_uuid != '') {
            res = `${emp.employee_place_of_birth_city_name}, ${this.dateParse(emp.employee_date_of_birth)}`;
        } else {
            res = `${emp.employee_place_of_birth_city_text}, ${this.dateParse(emp.employee_date_of_birth)}`;
        }
        return res;
    }

    toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

    loadData = async () => {
        /* history Datatable */
        sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))

        let additionalFilter = this.props.additionalFilter;

        /* kirim ke server */
        let offset = (this.state.filter.page_number-1)*this.state.filter.page_size
        if(this.state.defaultSize!==this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const query = {
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            status: 1,
            ...additionalFilter
        }
        await this.dataTableBloc.fetchRowTargetTable(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.inactiveData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }
    
    inactiveData = async () => {
        await this.dataTableBloc.fetchDelete({ uuid: this.state.inactiveUuid })
    }

    componentDidMount() {
        this.setTokenAPI()

        this.dataTableBloc.rowtargettableChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        detail: response.employee,
                        loadingTable: false
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.dataTableBloc.deleteChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                        loadingTable: true
                    }, function () {
                        this.setTokenAPI()
                        // this.props.handleInactiveSuccess()
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })
    }

    componentWillUnmount() {
        this.dataTableBloc.rowtargettableChannel.unsubscribe()
        this.dataTableBloc.deleteChannel.unsubscribe()
    }

    columns = [
        {
            key: "skp_activity",
            text: "Kegiatan",
            className: "skp_activity",
            sortable: true,
            width: '80'
        },
        
        {
            key: "skp_target_angka_kredit",
            text: "Target Angka Kredit",
            className: "skp_target_angka_kredit",
            sortable: true,
        },
        {
            key: "skp_target_kuantitas",
            text: "Target kuantitas",
            className: "skp_target_kuantitas",
            sortable: true,
        },
        {
            key: "skp_target_output",
            text: "Target Output",
            className: "skp_target_output",
            sortable: true,
        },
        {
            key: "skp_target_kualitas_mutu",
            text: "Target Kualitas Mutu",
            className: "skp_target_kualitas_mutu",
            sortable: true,
        },
        {
            key: "skp_target_waktu",
            text: "Target Waktu",
            className: "skp_target_waktu",
            sortable: true,
        },
        {
            key: "skp_target_satuan_waktu",
            text: "Target Satuan Waktu",
            className: "skp_target_satuan_waktu",
            sortable: true,
        },
        {
            key: "skp_target_biaya",
            text: "Target Biaya",
            className: "skp_target_biaya",
            sortable: true,
        },
        // realisasi
        {
            key: "skp_realisasi_angka_kredit",
            text: "Realisasi Angka Kredit",
            className: "skp_realisasi_angka_kredit",
            sortable: true,
        },
        {
            key: "skp_realisasi_kuantitas",
            text: "Realisasi kuantitas",
            className: "skp_realisasi_kuantitas",
            sortable: true,
        },
        {
            key: "skp_realisasi_output",
            text: "Realisasi Output",
            className: "skp_realisasi_output",
            sortable: true,
        },
        {
            key: "skp_realisasi_kualitas_mutu",
            text: "Realisasi Kualitas Mutu",
            className: "skp_realisasi_kualitas_mutu",
            sortable: true,
        },
        {
            key: "skp_realisasi_waktu",
            text: "Realisasi Waktu",
            className: "skp_realisasi_waktu",
            sortable: true,
        },
        {
            key: "skp_realisasi_satuan_waktu",
            text: "Realisasi Satuan Waktu",
            className: "skp_realisasi_satuan_waktu",
            sortable: true,
        },
        {
            key: "skp_realisasi_biaya",
            text: "Realisasi Biaya",
            className: "skp_realisasi_biaya",
            sortable: true,
        },
        {
            key: "skp_note_target_boss",
            text: "Catatan Target Penilai",
            className: "skp_note_target_boss",
            sortable: true,
        },
        {
            key: "skp_note_target_head_boss",
            text: "Catatan Target Atasan Penilai",
            className: "skp_note_target_head_boss",
            sortable: true,
        },
        {
            key: "skp_note_realisasi_boss",
            text: "Catatan Realisasi Penilai",
            className: "skp_note_realisasi_boss",
            sortable: true,
        },
        {
            key: "skp_note_realisasi_head_boss",
            text: "Catatan Realisasi Atasan Penilai",
            className: "skp_note_realisasi_head_boss",
            sortable: true,
        },
        {
            key: "action",
            text: "Action",
            className: "action",
            width: 120,
            sortable: false,
            align: 'center',
            cell: record => {
                const thisId = record.skp_period_id
                return (
                    <Fragment>
                        {/* { accessRole('delete') ?
                                <span className="me-1">
                                    <button 
                                        className="btn btn-danger btn-sm" 
                                        id={"delete-" + thisId}
                                        onClick={() => {
                                            this.setState({
                                                inactiveUuid: record.skp_period_uuid,
                                                confirm: true
                                            })
                                        }}
                                        style={{
                                            padding: '2px 5px'
                                        }}>
                                        <i className="uil-trash-alt"></i>
                                    </button>
                                    <Tooltip
                                        style={{
                                            marginBottom: 2
                                        }}
                                        placement="top" isOpen={this.state["delete" + thisId]} target={"delete-" + thisId}
                                        toggle={() => {
                                            this.setState({
                                                ["delete" + thisId] : !this.state["delete" + thisId]
                                            })
                                        }}
                                        >Hapus</Tooltip>
                                </span>
                            : ""
                        } */}

                    {/* { (accessRole('create') && record.skp_period_status==4) ?
                        <span>
                            <button
                                className="btn btn-warning btn-sm"
                                id={"detail-" + thisId}
                                onClick={() => {
                                    this.setState({
                                        detailUuid: record.skp_uuid
                                    })
                                }}
                                style={{
                                    marginRight: '2px',
                                    padding: '2px 5px'
                                }}>
                                    <i className="uil-comment-alt-edit"></i>
                            </button>
                            <Tooltip
                                style={{
                                    marginBottom: 2
                                }}
                                placement="top" isOpen={this.state["detail" + thisId]} target={"detail-" + thisId}
                                toggle={() => {
                                    this.setState({
                                        ["detail" + thisId] : !this.state["detail" + thisId]
                                    })
                                }}
                            >Input Realisasi</Tooltip>
                        </span>:''
                    } */}
                    </Fragment>
                );
            }
        }
    ]

    render() {
        return (
            <>
                

                <hr />

                <MKIDatatable
                    className={this.configDatatable.tableClass}
                    config={this.configDatatable}
                    records={this.state.rows}
                    columns={this.columns}
                    dynamic={true}
                    minWidth={1000}
                    total_record={this.state.totalRow}
                    initial={this.state.filter}
                    onChange={(filter) => {
                        this.setState({
                            loadingTable: true,
                            filter: filter
                        }, function () {
                            this.setTokenAPI()
                        });
                    }}
                    loading={this.state.loadingTable}
                />
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menghapus data ini?"

                    loadingTitle="Memproses data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil dihapus"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal dihapus"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.detailUuid !== null ?
                    // <Redirect to={"/sample.html?detail&uuid=" + this.state.detailUuid}/>
                    <Redirect to={"/kepegawaian/skp.html?input_realisasi&uuid=" + this.state.detailUuid}/>
                : null }
            </>
        )
    }

}

export default TableActiveComponent